import script from "./productDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./productDetails.vue?vue&type=script&setup=true&lang=js"

import "./productDetails.vue?vue&type=style&index=0&id=7f3b5f70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f3b5f70"]])

export default __exports__